/**
 * @module partnerBadge
 */

module.exports = function() {
    // move partner image to main menu
    const badge = document.querySelector('.authorized-solution-partner'),
          menu  = document.querySelectorAll('.main_menu__nav .navbar-brand');

    menu[0].parentNode.insertBefore(badge, menu.nextSibling);
    menu[1].parentNode.insertBefore(badge.cloneNode(true), menu.nextSibling);
}; // exports